import React, { SVGProps } from 'react';

const SvgPerson = (props: SVGProps<SVGSVGElement>) => {
	return (
		// <svg
		// 	xmlns='http://www.w3.org/2000/svg'
		// 	height='1em'
		// 	viewBox='0 0 24 24'
		// 	width='1em'
		// 	fill='currentColor'
		// 	className='svg-icon'
		// 	{...props}>
		// 	<path d='M0 0h24v24H0V0z' fill='none' />
		// 	<path d='M12 16c-2.69 0-5.77 1.28-6 2h12c-.2-.71-3.3-2-6-2z' opacity={0.3} />
		// 	<circle cx={12} cy={8} opacity={0.3} r={2} />
		// 	<path d='M12 14c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4zm-6 4c.22-.72 3.31-2 6-2 2.7 0 5.8 1.29 6 2H6zm6-6c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0-6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2z' />
		// </svg>

		<svg xmlns="http://www.w3.org/2000/svg" width="15" height="14" viewBox="0 0 15 14" fill="none" {...props}>
			<path d="M7.01074 8.4C8.94374 8.4 10.5107 6.5196 10.5107 4.2C10.5107 1.8804 8.94374 0 7.01074 0C5.07775 0 3.51074 1.8804 3.51074 4.2C3.51074 6.5196 5.07775 8.4 7.01074 8.4Z" fill="white" />
			<path d="M13.8711 11.9702C13.2411 10.7102 12.0511 9.66019 10.5111 9.03019C10.0911 8.89019 9.60109 8.89019 9.25109 9.10019C8.55109 9.52019 7.85109 9.73019 7.01109 9.73019C6.17109 9.73019 5.47109 9.52019 4.77109 9.10019C4.42109 8.96019 3.93109 8.89019 3.51109 9.10019C1.97109 9.73019 0.781089 10.7802 0.151089 12.0402C-0.338911 12.9502 0.431089 14.0002 1.48109 14.0002H12.5411C13.5911 14.0002 14.3611 12.9502 13.8711 11.9702Z" fill="white" />
		</svg>
	);
}

export default SvgPerson;
